import { Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { styled } from 'styled-components';

import { Container } from 'src/components/container';
import { breakpointLargeTablet } from 'src/styles/breakpoints';
import { placeholder } from 'src/styles/mixins';
import { spacing1, spacing4, spacing13, spacing7, spacing8, spacing9 } from 'src/styles/spacing';

export const StyledContainer = styled(Container)`
  margin-top: ${spacing8};
  margin-bottom: ${spacing13};

  @media (min-width: ${breakpointLargeTablet}) {
    margin: ${spacing8} auto ${spacing9};
  }
`;

export const StyledHeading = styled(Typography)`
  text-align: center;
  margin-bottom: ${spacing4};

  @media (min-width: ${breakpointLargeTablet}) {
    margin-bottom: ${spacing8};
  }
`;

export const StyledSuccessItems = styled.div`
  margin-bottom: ${spacing7};

  @media (min-width: ${breakpointLargeTablet}) {
    margin-bottom: ${spacing13};
  }
`;

export const StyledTitle = styled(Typography)`
  font-weight: bold;
  padding-bottom: ${spacing1};
`;

export const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const StyledHeadingPlaceholder = styled.div`
  ${placeholder};
  height: 48px;
  max-width: 554px;
  margin: 0 auto ${spacing4};

  @media (min-width: ${breakpointLargeTablet}) {
    margin: 0 auto ${spacing8};
  }
`;
